import Quiz from './components/Quiz/Quiz';
import AdvtFullSize from './components/AdvtFullSize/AdvtFullSize';
import { useGetParams } from './hooks/useGetParams';
import { Winner } from './components/Winner/Winner';

import { useVote } from './hooks/useVote';
import { useMemo } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { CSSTransition } from 'react-transition-group';

import posterDefault from './assets/images/poster.png';
import bgDefaultVideo from './assets/video/bgVideo.mp4';

import bgWinners from './assets/video/bgWinners.mp4';
import posterWinners from './assets/images/posterWinners.png';

import logo from './assets/images/logo.png';

function App() {
  const { voteState, currentState, isVisible } = useVote();

  const {
    bg,
    advtImage,
    phoneNumber,
    socials,
    title,
    qrCode1,
    qrCode2,
    questionFontSize,
    answerFontSize,
    varNumFontSize,
    winnerFontSize,
    bgVideo,
    bgPoster,
  } = useGetParams();

  const advt_info = useMemo(
    () => ({
      advtImage,
      qrCode1,
      qrCode2,
      label: title,
      number: phoneNumber,
      socials: socials?.split(','),
    }),
    [advtImage, phoneNumber, socials, title, qrCode1, qrCode2]
  );

  return (
    <div className="app-wrapper">
      <CSSTransition
        in={isVisible && ['S2', 'S3'].includes(currentState)}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit>
        <AdvtFullSize advtInfo={advt_info} />
      </CSSTransition>

      <CSSTransition
        in={isVisible && voteState && ['S2', 'S3'].includes(currentState)}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit>
        <Quiz
          variants={voteState?.vars}
          title={voteState?.title}
          questionImgUrl={voteState?.questionImgUrl}
          currentState={currentState}
          questionFontSize={questionFontSize}
          answerFontSize={answerFontSize}
          varNumFontSize={varNumFontSize}
          winnerFontSize={winnerFontSize}
        />
      </CSSTransition>

      <CSSTransition
        in={isVisible && ['S4'].includes(currentState)}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit>
        <Winner
          questionImgUrl={voteState?.questionImgUrl}
          winnerFontSize={winnerFontSize}
        />
      </CSSTransition>

      <AnimatePresence mode="wait">
        {bgVideo && currentState !== 'S4' && (
          <motion.video
            key="bgMain"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              duration: 0.5,
            }}
            autoPlay="autoplay"
            muted="muted"
            loop
            id="bgVideo"
            poster={bgVideo === '1' ? posterDefault : bgPoster}>
            <source
              src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
              type="video/mp4"></source>
          </motion.video>
        )}
      </AnimatePresence>

      <video
        autoPlay="autoplay"
        muted="muted"
        loop
        id="bgVideoWinners"
        poster={posterWinners}>
        <source src={bgWinners} type="video/mp4"></source>
      </video>

      <img src={logo} alt="logo" className="logo" />

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
